// tax bracket calculator
import { calculateTaxBracket as calculateTaxBracketFunction } from "./taxBracketCalculator";
// sales tax calculator
import { calculateSalesTax as calculateSalesTaxFunction } from "./salesTaxCalculator"
import { getTaxRate as getRateByZipcodeFunction } from "./salesTaxCalculator"
// small business tax calculator
import { calculateSmallBusinessTax as calculateSmallBusinessTaxFunction} from "./smallBusinessTaxCalculator";

export const calculateTaxBracket = calculateTaxBracketFunction;
export const calculateSalesTax = calculateSalesTaxFunction;
export const getTaxRate = getRateByZipcodeFunction;
export const calculateSmallBusinessTax = calculateSmallBusinessTaxFunction;
